/**
 * ÖLÇÜM KAPISI BYPASS'I — saf yüklem, tek kaynak, test edilebilir.
 *
 * ── NEDEN AYRI DOSYA ─────────────────────────────────────────────────────
 * `App.tsx`'teki profil kapısı KOŞULSUZ `return` ediyor; altındaki ekran hiç
 * render edilmiyor. "Profil olmadan hangi ekran gerçekten çöküyor?" sorusunu
 * ölçmenin başka yolu yok — kapının arkasına bakmak için geçici bir anahtar
 * gerekiyor (C7: sinyal kancasız gerçekten ulaşılamaz).
 *
 * Anahtarın ÜRETİMDE ÖLÜ olduğu bir İDDİA olarak kalamaz: doğrulanmamış
 * güvenlik iddiası, iddia değildir. Yüklem bu yüzden App.tsx içine gömülü
 * bırakılmadı — ayrı ve saf, böylece `kapiOlcumBypass.test.ts` onu doğrudan
 * ateşleyebiliyor (K9 dersi: ateşlendiği görülmeden yeşil sayılmaz).
 *
 * ÇİFT KAPI:
 *   1. `eyeMode` — YALNIZ localhost/127.0.0.1 + `?eye=1` (src/firebase.ts).
 *      Prod host'ta `?eye=1` verilse bile false kalır.
 *   2. Açık `localStorage` işareti — kaza eseri açılmasın.
 * İkisi birden olmadan kapı aynen çalışır.
 */
export const KAPI_BYPASS_ANAHTARI = "mylasa.vw.kapiBypass";

type Depo = { getItem: (k: string) => string | null } | null | undefined;

export function kapiOlcumBypassAcikMi(eyeMode: boolean, depo: Depo): boolean {
  // EYE_MODE kapılı ilk şart: false ise depo ne derse desin KAPALI.
  if (!eyeMode) return false;
  try {
    return depo?.getItem(KAPI_BYPASS_ANAHTARI) === "1";
  } catch {
    // Depoya erişilemiyorsa (gizli sekme, kısıtlı ortam) GÜVENLİ TARAF: kapalı.
    return false;
  }
}
